import { Injectable } from "@angular/core";
import JsonHelper from "../utils/json-helper";
import { AuthToken } from "../models/auth-token";
import { UrlParam } from "../models/url-param";
import { BasketItemRequest } from "../dtos/basket-item.request.dto";
import { UserDataModel } from "../models/user-data.model";

@Injectable({ providedIn: 'root' })
export class SessionStorageService {
    private TOKEN_KEY = 'token';
    private URLPARAM_KEY = "urlparams";
    private BASKET_KEY = "basket";
    private USERDATA_KEY = "userdata";    

    // -- TOKEN
    public hasToken() {
        const token = sessionStorage.getItem(this.TOKEN_KEY);
        return token === null ? false : true
    }

    public getAuthToken(): AuthToken {
        const token = sessionStorage.getItem(this.TOKEN_KEY);
        if (!token)
            return null as AuthToken;

        let parsedObject: AuthToken = JsonHelper.Deserialize(this.decrypt(token)) as AuthToken;
        return parsedObject;
    }

    public setAuthToken(token: AuthToken) {
        sessionStorage.setItem(this.TOKEN_KEY, this.encrypt(JSON.stringify(token)));
    }

    clearToken() {
        sessionStorage.removeItem(this.TOKEN_KEY);
    }


    // -- URL PARAM
    public saveUrlParams(param: UrlParam) {
        sessionStorage.setItem(this.URLPARAM_KEY, JSON.stringify(param))
    }

    public getUrlParams(): UrlParam {
        return JSON.parse(sessionStorage.getItem(this.URLPARAM_KEY)) as UrlParam;
    }

    public clearUrlParams() {
        sessionStorage.removeItem(this.URLPARAM_KEY);
    }

    public updateLanguageInUrlParams(languageCode: string) {
        let urlparamsFromSessionStorage: UrlParam = this.getUrlParams();
        urlparamsFromSessionStorage.Language = languageCode;
        this.saveUrlParams(urlparamsFromSessionStorage);
    }

    getBasketKey(): string {
        let key: string = this.BASKET_KEY;
        var urlParams: UrlParam = this.getUrlParams();
        if (!urlParams)
            return key;

        return `${key}_${urlParams.Subscriber}_${urlParams.HotelId}`;
    }

    // -- BASKET
    saveBasket(basket: BasketItemRequest[]) {
        sessionStorage.setItem(this.getBasketKey(), this.encrypt(JSON.stringify(basket)))
    }

    getBasket(): BasketItemRequest[] {
        let item: BasketItemRequest[] = <BasketItemRequest[]>JSON.parse(this.decrypt(sessionStorage.getItem(this.getBasketKey())));
        return item;
    }

    clearBasket() {
        sessionStorage.removeItem(this.getBasketKey());
    }

    getUserdataKey(): string {
        let key: string = this.USERDATA_KEY;
        var urlParams: UrlParam = this.getUrlParams();
        if (!urlParams)
            return key;

        return `${key}_${urlParams.Subscriber}_${urlParams.HotelId}`;
    }


    // -- USERDATA
    saveUserData(userData: UserDataModel) {
        sessionStorage.setItem(this.getUserdataKey(), this.encrypt(JSON.stringify(userData)));
    }

    getUserData(): UserDataModel {
        return JSON.parse(this.decrypt(sessionStorage.getItem(this.getUserdataKey()))) as UserDataModel;
    }

    clearUserData() {
        sessionStorage.removeItem(this.getUserdataKey());
    }

    private key = "HostWareEncryptedLocalStorage";
    private encrypt(text: string): string {
        if (!text)
            return null;

        // if (environment.production)
        //     return CryptoJS.AES.encrypt(text, this.key).toString();
        // else
        return text;
    }

    private decrypt(text: string) {
        if (!text)
            return null;

        // if (environment.production)
        //     return CryptoJS.AES.decrypt(text, this.key).toString(CryptoJS.enc.Utf8);
        // else
        return text;
    }

    public get Language(): string {
        const urlParam: UrlParam = this.getUrlParams();
        if (!urlParam)
            return null;

        return urlParam.Language;
    }

    readonly returnUrlKey: string = "returnUrl";
    public setReturnUrl(returnUrl: string) {
        sessionStorage.setItem(this.returnUrlKey, returnUrl);
    }

    public getReturnUrl(): string | null {
        return sessionStorage.getItem(this.returnUrlKey);
    }

    public clearReturnUrl(): string | null {
        return sessionStorage.remove(this.returnUrlKey);
    }
}
